module.exports = __webpack_public_path__ + "static/bg-sidebar-math-calculators-86695e2fc1ac833cee747fa0c64bf38c.svg";